import { memoize } from "lodash";
import { getResourceIcon, getResourceIconByName } from "../features/generic/icon/getResourceIcon";
import { utilBalancing } from "../utils/utilBalancing";
import { utilNumber } from "../utils/utilNumber";
import { selectPlayerProfilePictureName } from "./selectBalancingPictures";
import { selectResourceInfo } from "./selectBalancingResources";
export var selectBalancingRandomPools = function () { return utilBalancing.getBalancing().RandomPools; };
export var selectBalancingRandomPool = memoize(function (poolId) { return selectBalancingRandomPools().get(poolId); });
export var selectTopRewardResourcesIcon = memoize(function (poolId) {
    var randomPools = selectBalancingRandomPool(poolId);
    return randomPools.topReward.map(function (rewardResource) {
        return getResourceIconByName(rewardResource.shownIcon);
    });
});
export var selectPoolRewardsIconInfo = memoize(function (poolId) {
    var poolContent = selectBalancingRandomPool(poolId).poolContent;
    var poolRewards = [];
    if (poolContent == undefined) {
        return poolRewards;
    }
    var totalWeight = poolContent.reduce(function (acc, val) { return acc + val.weight; }, 0);
    var pictureIdDropPercentageMap = new Map();
    var resourceIdDropPercentageMap = new Map();
    poolContent.forEach(function (reward) {
        var pictureReward = reward.pictureReward, resourceReward = reward.resourceReward, weight = reward.weight;
        if (pictureReward != undefined) {
            pictureReward.forEach(function (_a) {
                var pictureId = _a.pictureId;
                var dropPercentage = utilNumber.roundToPrecision((weight / totalWeight) * 100, 1);
                if (pictureIdDropPercentageMap.has(pictureId)) {
                    dropPercentage += pictureIdDropPercentageMap.get(pictureId);
                }
                pictureIdDropPercentageMap.set(pictureId, dropPercentage);
            });
        }
        if (resourceReward != undefined) {
            resourceReward.forEach(function (_a) {
                var resourceId = _a.resourceId;
                var dropPercentage = utilNumber.roundToPrecision((weight / totalWeight) * 100, 1);
                if (resourceIdDropPercentageMap.has(resourceId)) {
                    dropPercentage += resourceIdDropPercentageMap.get(resourceId);
                }
                resourceIdDropPercentageMap.set(resourceId, dropPercentage);
            });
        }
    });
    pictureIdDropPercentageMap.forEach(function (dropPercentage, key) {
        var pictureIcon = selectPlayerProfilePictureName(key);
        poolRewards.push({
            amount: dropPercentage,
            icon: pictureIcon,
        });
    });
    resourceIdDropPercentageMap.forEach(function (dropPercentage, key) {
        var resourceInfo = selectResourceInfo(key);
        var resourceIcon = getResourceIcon(resourceInfo);
        poolRewards.push({
            amount: dropPercentage,
            icon: resourceIcon,
            loca: resourceInfo.locaKey,
        });
    });
    return poolRewards;
});
export var balancingRandomPoolsMemoizedFunctions = [
    selectBalancingRandomPools,
    selectBalancingRandomPool,
    selectTopRewardResourcesIcon,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingRandomPools.ts
// module id = 235
// module chunks = 3